import { getCurrentProfile, getPosProfileById, getUserProfiles } from './profile';
import { updateUserSettings } from './settings';

export const UserAPI = {
  updateUserSettings,
  getCurrentProfile,
  getPosProfileById,
  getUserProfiles,
};
